import UserData from "./UserData";
import { Tag } from "pepsico-ds";
import { useAppSelector } from "../../../hooks/app";
import "./profileStyle.css";
import { ROLES } from "../../../config/roles";

function Profile() {
  const { data } = useAppSelector((state) => state.userAccess);
  const roles = [
    ROLES.admin.displayText,
    ROLES.gpLead.displayText,
    ROLES.stLead.displayText,
  ];
  const userRoles = data?.userRoles.map((role) => (
    <Tag text={role.role.name} key={role.role.id} isCopyable={false} />
  ));
  const isAdmin = data?.userRoles.some(
    (role) => role.role.name === ROLES.admin.displayText
  );

  const showSectors = data?.userRoles.some((role) =>
    roles.includes(role.role.name)
  );
  const userSectors = data?.userSectors.map((sector) => (
    <Tag
      text={sector.sectors.name}
      key={sector.sectors.id}
      isCopyable={false}
    />
  ));

  return (
    <div>
      <div className="profile-container">
        <div className="profile-column basic-details">
          <UserData title="First Name" description={data?.first_name} />
          <UserData title="Last Name" description={data?.last_name} />
          <UserData title="Email" description={data?.email} />
        </div>
        <div className="profile-column">
          <UserData
            title="Roles"
            description={<div className="tag-container">{userRoles}</div>}
          />
          <UserData
            title="Sectors"
            description={
              showSectors ? (
                <div className="tag-container">
                  {isAdmin ? (
                    <Tag text={"All Sectors"} isCopyable={false} />
                  ) : (
                    userSectors
                  )}
                </div>
              ) : (
                "N/A"
              )
            }
          />
        </div>
      </div>
    </div>
  );
}

export default Profile;
